import { HealthStatus } from '@casops/store/apis/commonModels';
import { setHealthStatus } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import SingleSelectFilter from '../single-select/SingleSelectFilter';
import { FilterInputProps } from '@casops/filters/types';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';

const useHealthStatusOptions = (): DropdownItemProps<HealthStatus>[] => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.values(HealthStatus).map(value => ({
        key: value,
        value,
        stringValue: value,
        label: t(value),
      })),
    [t],
  );
};

export const HealthStatusFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();
  return (
    <SingleSelectFilter<HealthStatus>
      filterName="healthStatus"
      label={label ?? t('Fields.Filters.HealthStatus')}
      elementRef={elementRef}
      action={setHealthStatus}
      useItemsHook={useHealthStatusOptions}
    />
  );
};

export default HealthStatusFilter;
